module.exports = __webpack_public_path__ + "img/party-popper.6815e436.png";